// src/redux/store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage
import { persistStore, persistReducer } from "redux-persist";
import communityReducer from "../Services/Community/CommunitySlice/communitySlice";
import communitybyNameReducer from "../Services/Community/CommunitySlice/communityByCommunityNameSlice";
import communityByIdReducer from "../Services/Community/CommunitySlice/communityByIdSlice";
import userLoginReducer from "../Services/Login/LoginSlice/loginSlice";
import forgotPasswordReducer from "../Services/Login/LoginSlice/ForgotPasswordslice";
import otpVerificationReducer from "../Services/Login/LoginSlice/otpverificationSlice";
import userResetPasswordReducer from "../Services/Login/LoginSlice/ResetPasswordSlice";
import userSignUpReducer from "../Services/Signup/SignupSlice/SignupSlice";
import fetchUserTypeReducer from "../Services/Signup/SignupSlice/userTypeSlice";
import idReducer from "../Services/Community/CommunitySlice/idSlice";
import communityDocNameReducer from "../Services/Community/CommunitySlice/communityDocName";
import createNewCommunitySlice from "../Services/Community/CommunitySlice/createNewCommunitySlice";
import createNewCommunityGptSlice from "../Services/Community/CommunitySlice/createNewCommunityGptSlice";
import vendorCheckOrCreateSlice from "../Services/Community/CommunitySlice/vendorCheckOrCreate";
import communityUpdateSlice from "../Services/Community/CommunitySlice/communityUpdateSlice";
import uploadDocumentsSlice from "../Services/DocumentUpload/documentSlice/documentUploadSlice";
import getDocTypeApiSlice from "../Services/DocumentUpload/documentSlice/doctypeSlice";
import getAllDocumentSlice from "../Services/DocumentUpload/documentSlice/getDocumentSlice";
import updateDocumentSlice from "../Services/DocumentUpload/documentSlice/updateDocumentSlice";
import getDocumentbyIdSlice from "../Services/DocumentUpload/documentSlice/documentGetByIdSlice";
import healthVendorCheckOrCreateSlice from "../Services/Community/CommunitySlice/healthVendorCheckOrCreate";
import fetchProfileDataSlice from "../Services/Profile/ProfileSlice";
import uiReducer from "../Services/DashboardHeader/uiSlice";
import claimCommunitySlice from "../Services/Community/ClaimCommunity/claimCommunitySlice";
import fetchclaimCommunitySlice from "../Services/Community/ClaimCommunity/fetchClaimCommunitySlice";
import updateClaimSlice from "../Services/Community/ClaimCommunity/updateClaimSlice";
import updateProfileApiSlice from "../Services/updateProfile/updateProfileSlice";
import HomeOwnerAllDataSlice from "../Services/Homeowner/homeownerSlice/getHomeOwnerSlice";
import HomeOwnerCreateDataSlice from "../Services/Homeowner/homeownerSlice/createCommuniHomeOwnerSlice";
import getAllAssignHomeOwnerDataSlice from "../Services/Homeowner/homeownerSlice/getAllAssignHomeOwnerSlice";
import educationVendorCheckOrCreateSlice from "../Services/Community/CommunitySlice/educationVendorCheckOrCreate";
import fetchUserDataSlice from "../Services/UserManagement/UserManagementSlice/fetchUserDataSlice";
import updateUserStatusSlice from "../Services/UserManagement/UserManagementSlice/updateUserStatusSlice";
import addMultipleHomeOwnersSlice from "../Services/Homeowner/homeownerSlice/addMultipleHomeOwners";
import fetchApprovalCommunityDataSlice from "../Services/Community/CommunitySlice/fetchApprovalCommunitySlice";
import updateApprovalCommunityDataSlice from "../Services/Community/CommunitySlice/updateApprovalCommunitySlice";
import fetchDocumentApprovalsByCommunityIdSlice from "../Services/Community/Approvals/fetchDocumentApprovalsByCommunityIdSlice";
import updateVisitorDocumentStatusSlice from "../Services/Community/Approvals/updateVisitorDocumentStatusSlice";
import fetchFactCheckApprovalsByCommunityIdSlice from "../Services/Community/Approvals/fetchFactCheckApprovalsByCommunityIdSlice";
import updateFactCheckStatusSlice from "../Services/Community/Approvals/updateFactCheckStatusSlice";
import Ai_traning_DataSlice from "../Services/AI-Training/AItrainingSlice";
import Ai_traning_Data_updateSlice from "../Services/AI-Training/AItrainingupdateSlice";
import fetchFactCheckApprovalsSlice from "../Services/Community/Approvals/fetchFactCheckApprovals";
import fetchDocumentApprovalsSlice from "../Services/Community/Approvals/fetchDocumentApprovals";
import AllCountApiSlice from "../Services/AllCountApi/AllCountSlice";
import getDashboardCountSlice from "../Services/Dashboar-CountApi/dashboardCountSlice";
import fetchUserCommunityDataSlice from "../Services/UserManagement/UserManagementSlice/fetchUserCommunityDataSlice";
import fetchAllAiTrainingDataSlice from "../Services/AI-Training/fetchAllAiTrainingDataSlice";
import fetchCommunityDataWithPaginationSlice from "../Services/Community/CommunitySlice/communityByPaginationSlice";
import fetchTaskStatusSlice from "../Services/DocumentUpload/documentSlice/fetchTaskStatusSlice";
import fetchInsuranceTaskStatusSlice from "../Services/DocumentUpload/documentSlice/insuranceTaskStatusSlice";
import fetchFinanceTaskStatusSlice from "../Services/DocumentUpload/documentSlice/financeTaskStatusSlice";
import fetchProductListSlice from "../Services/Subscription/SubscriptionSlice/fetchProductListSlice";
import fetchUserSubscriptionsSlice from "../Services/Subscription/SubscriptionSlice/fetchUserSubscriptionsSlice";
import fetchRevenueSubscriptionsSlice from "../Services/Subscription/SubscriptionSlice/fetchRevenueSubscriptions";
import fetchUserProfileSlice from "../Services/UserManagement/UserManagementSlice/fetchUserProfileSlice";
import fetchGroupDataSlice from "../Services/Community/CommunitySlice/fetchGroupDataSlice";
import fetchCommunityHomeownerSlice from "../Services/Community/CommunitySlice/CommunityHomeownerSlice";
import fetchAllFloridaChaptersSlice from "../Services/Community/CommunitySlice/fetchAllFloridaChaptersSlice";
import complianceTaskSlice from "../Services/Community/CompliaceSlice/complianceTaskSlice";
import overallRatingSlice from "../Services/Community/RatingsAPI/overallRatingSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "ui",
    "complianceTask",
    "fetchTaskStatus",
    "insuranceTaskStatus",
    "financeTaskStatus",
  ], // Persist ui, task status slices for loader persistence across reloads
};

// Combine Reducers
const rootReducer = combineReducers({
  community: communityReducer,
  communityByName: communitybyNameReducer,
  communityById: communityByIdReducer,
  userLogin: userLoginReducer,
  forgotPassword: forgotPasswordReducer,
  otpVerification: otpVerificationReducer,
  userResetPassword: userResetPasswordReducer,
  userSignUp: userSignUpReducer,
  fetchUserType: fetchUserTypeReducer,
  id: idReducer,
  communityDocName: communityDocNameReducer,
  createNewCommunity: createNewCommunitySlice,
  createNewCommunityGpt: createNewCommunityGptSlice,
  vendorCheckOrCreate: vendorCheckOrCreateSlice,
  communityUpdate: communityUpdateSlice,
  healthVendorCheckOrCreate: healthVendorCheckOrCreateSlice,
  getDocType: getDocTypeApiSlice,
  uploadDocuments: uploadDocumentsSlice,
  getAllDocument: getAllDocumentSlice,
  updateDocument: updateDocumentSlice,
  fetchProfileData: fetchProfileDataSlice,
  getDocumentbyId: getDocumentbyIdSlice,
  ui: uiReducer,
  claimCommunity: claimCommunitySlice,
  fetchclaimCommunity: fetchclaimCommunitySlice,
  updateClaim: updateClaimSlice,
  profileUpdate: updateProfileApiSlice,
  HomeOwnerAllData: HomeOwnerAllDataSlice,
  HomeOwnerCreateData: HomeOwnerCreateDataSlice,
  getAllAssignHomeOwnerData: getAllAssignHomeOwnerDataSlice,
  educationVendorCheckOrCreate: educationVendorCheckOrCreateSlice,
  fetchUserData: fetchUserDataSlice,
  updateUserStatus: updateUserStatusSlice,
  addMultipleHomeOwners: addMultipleHomeOwnersSlice,
  fetchApprovalCommunityData: fetchApprovalCommunityDataSlice,
  updateApprovalCommunityData: updateApprovalCommunityDataSlice,
  fetchDocumentApprovalsByCommunityId: fetchDocumentApprovalsByCommunityIdSlice,
  updateVisitorDocumentStatus: updateVisitorDocumentStatusSlice,
  fetchFactCheckApprovalsByCommunityId:
    fetchFactCheckApprovalsByCommunityIdSlice,
  updateFactCheckStatus: updateFactCheckStatusSlice,
  Ai_traning_Data: Ai_traning_DataSlice,
  Ai_traning_Data_update: Ai_traning_Data_updateSlice,
  fetchDocumentApprovals: fetchDocumentApprovalsSlice,
  fetchFactCheckApprovals: fetchFactCheckApprovalsSlice,
  AllCountApi: AllCountApiSlice,
  getDashboardCount: getDashboardCountSlice,
  fetchUserCommunityData: fetchUserCommunityDataSlice,
  fetchAllAiTrainingData: fetchAllAiTrainingDataSlice,
  fetchCommunityDataWithPagination: fetchCommunityDataWithPaginationSlice,
  fetchTaskStatus: fetchTaskStatusSlice,
  insuranceTaskStatus: fetchInsuranceTaskStatusSlice,
  financeTaskStatus: fetchFinanceTaskStatusSlice,
  fetchProductList: fetchProductListSlice,
  fetchUserSubscriptions: fetchUserSubscriptionsSlice,
  fetchRevenueSubscriptions: fetchRevenueSubscriptionsSlice,
  fetchUserProfile: fetchUserProfileSlice,
  fetchGroupData: fetchGroupDataSlice,
  fetchCommunityHomeowner: fetchCommunityHomeownerSlice,
  fetchAllFloridaChapters: fetchAllFloridaChaptersSlice,
  complianceTask: complianceTaskSlice,
  overallRating: overallRatingSlice,
});

// Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure Store
const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store); // Export persistor
export default store;
